import { render } from "./Terms_Conditions.vue?vue&type=template&id=69852794&scoped=true"
import script from "./Terms_Conditions.vue?vue&type=script&lang=js"
export * from "./Terms_Conditions.vue?vue&type=script&lang=js"

import "./Terms_Conditions.vue?vue&type=style&index=0&id=69852794&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69852794"]])

export default __exports__